<template>
  <div class="expediting-fees-plan-contenzioso2">
    <div class="expediting-fees-plan-contenzioso2-header">
      <el-button type="primary" @click="getList">刷新</el-button>
      <el-button type="primary" @click="exportExcel">导出年度诉讼计划模板</el-button>
      <el-button type="primary" @click="importExcel">导入年度诉讼计划模板</el-button>
      <el-button type="primary" @click="$refs.courtWinRef.open()">法院管理</el-button>
    </div>
    <HeaderTip>
      总项目数：{{statistics.count}}&nbsp;&nbsp;&nbsp;&nbsp;已导入项目：{{statistics.use_count}}&nbsp;&nbsp;&nbsp;&nbsp;
      未导入项目：{{statistics.not_use_count}}&nbsp;&nbsp;&nbsp;&nbsp;有一年以上欠费项目：{{statistics.one_year_more_count}}&nbsp;&nbsp;&nbsp;&nbsp;
    </HeaderTip>
    <el-table :data="pageData.data" v-loading="loading" style="width: 100%" height="65vh" border ref="fTableRef">
      <el-table-column prop="project_name" label="项目名称" align="center" width="200" fixed></el-table-column>
      <el-table-column label="上年度项目诉讼基础信息" align="center">
        <el-table-column prop="court_name" label="管辖法院" align="center" width="200"></el-table-column>
        <el-table-column prop="restrictions" label="立案限制（月）" align="center" width="100"></el-table-column>
        <el-table-column label="历史欠费总数据" align="center">
          <el-table-column prop="history_total_num" label="户数" align="center" width="100"></el-table-column>
          <el-table-column prop="history_total_amount" label="金额" align="center" width="120"></el-table-column>
        </el-table-column>
        <el-table-column label="一年以内欠费" align="center">
          <el-table-column prop="one_year_less_num" label="户数" align="center" width="100"></el-table-column>
          <el-table-column prop="one_year_less_amount" label="金额" align="center" width="120"></el-table-column>
        </el-table-column>
        <el-table-column label="一年以上欠费" align="center">
          <el-table-column prop="one_year_more_num" label="户数" align="center" width="100"></el-table-column>
          <el-table-column prop="one_year_more_amount" label="金额" align="center" width="120"></el-table-column>
        </el-table-column>

<!--        <el-table-column label="提交法院取得立案" align="center">-->
<!--          <el-table-column prop="filed_case_num" label="户数" align="center" width="100"></el-table-column>-->
<!--          <el-table-column prop="filed_case_amount" label="金额" align="center" width="120"></el-table-column>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="提交法院取得立案号-未回款" align="center">-->
<!--          <el-table-column prop="filed_no_refund_num" label="户数" align="center" width="100"></el-table-column>-->
<!--          <el-table-column prop="filed_no_refund_amount" label="金额" align="center" width="120"></el-table-column>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="提交法院后立案前成功回款（诉调）" align="center">-->
<!--          <el-table-column prop="pre_filed_settlement_num" label="户数" align="center" width="100"></el-table-column>-->
<!--          <el-table-column prop="pre_filed_settlement_amount" label="金额" align="center" width="120"></el-table-column>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="提交法院未立案未调解未取回" align="center">-->
<!--          <el-table-column prop="filed_no_action_num" label="户数" align="center" width="100"></el-table-column>-->
<!--          <el-table-column prop="filed_no_action_amount" label="金额" align="center" width="120"></el-table-column>-->
<!--        </el-table-column>-->
        <el-table-column label="无诉业主信息/房产资料" align="center">
          <el-table-column prop="no_litigation_info_num" label="户数" align="center" width="100"></el-table-column>
          <el-table-column prop="no_litigation_info_amount" label="金额" align="center" width="120"></el-table-column>
        </el-table-column>


        <el-table-column label="超过诉讼时效" align="center">
          <el-table-column prop="exceed_limitation_num" label="户数" align="center" width="100"></el-table-column>
          <el-table-column prop="exceed_limitation_amount" label="金额" align="center" width="120"></el-table-column>
        </el-table-column>
<!--        <el-table-column label="自诉" align="center">-->
<!--          <el-table-column prop="self_prosecution_num" label="户数" align="center" width="100"></el-table-column>-->
<!--          <el-table-column prop="self_prosecution_amount" label="金额" align="center" width="120"></el-table-column>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="第三方诉讼" align="center">-->
<!--          <el-table-column prop="third_party_litigation_num" label="户数" align="center" width="100"></el-table-column>-->
<!--          <el-table-column prop="third_party_litigation_amount" label="金额" align="center" width="120"></el-table-column>-->
<!--          <el-table-column prop="third_party_name" label="第三方名称" align="center" width="120"></el-table-column>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="已立案数量（含已提交）" align="center">-->
<!--          <el-table-column prop="filed_total_num" label="户数" align="center" width="100"></el-table-column>-->
<!--          <el-table-column prop="filed_total_amount" label="金额" align="center" width="120"></el-table-column>-->
<!--        </el-table-column>-->
      </el-table-column>
      <el-table-column label="2026年项目年度（一年以上）诉讼计划" align="center" width="4710">
        <el-table-column label="年度目标收缴率（一年以上）" align="center">
          <el-table-column prop="annual_collection_rate" label="收缴率" align="center" width="100"></el-table-column>
          <el-table-column prop="annual_collection_rate_num" label="户数" align="center" width="100"></el-table-column>
          <el-table-column prop="annual_collection_rate_amount" label="金额" align="center" width="120"></el-table-column>
<!--          <el-table-column prop="annual_collection_rate_ratio" label="比例" align="center" width="120"></el-table-column>-->
        </el-table-column>
        <el-table-column label="上一年度已立案情况" align="center">
          <el-table-column prop="last_filing_plan_num" label="户数" align="center" width="100"></el-table-column>
          <el-table-column prop="last_filing_plan_amount" label="金额" align="center" width="120"></el-table-column>
        </el-table-column>

        <el-table-column label="本年立案计划" align="center">
          <el-table-column prop="annual_filing_plan_num" label="户数" align="center" width="100"></el-table-column>
          <el-table-column prop="annual_filing_plan_amount" label="金额" align="center" width="120"></el-table-column>
<!--          <el-table-column prop="annual_filing_plan_ratio" label="收缴率占比" align="center" width="120"></el-table-column>-->
        </el-table-column>

        <el-table-column label="本年已立案数量" align="center">
          <el-table-column prop="year_registered_num" label="户数" align="center" width="100"></el-table-column>
          <el-table-column prop="year_registered_amount" label="金额" align="center" width="120"></el-table-column>
        </el-table-column>
        <el-table-column label="本年立案差异" align="center">
          <el-table-column prop="year_filing_diff_num" label="户数" align="center" width="100"></el-table-column>
          <el-table-column prop="year_filing_diff_amount" label="金额" align="center" width="120"></el-table-column>
        </el-table-column>

<!--        <el-table-column label="年度自催计划" align="center">-->
<!--          <el-table-column prop="annual_self_collection_plan_num" label="户数" align="center" width="100"></el-table-column>-->
<!--          <el-table-column prop="annual_self_collection_plan_amount" label="金额" align="center" width="120"></el-table-column>-->
<!--          <el-table-column prop="annual_self_collection_plan_ratio" label="收缴率占比" align="center" width="120"></el-table-column>-->
<!--        </el-table-column>-->
        <el-table-column label="" align="center" width="2800">
          <template #header>
            <div class="expediting-fees-plan-table-header">
              <div class="expediting-fees-plan-table-header-title">类目</div>
              <el-table :data="[]" :show-header="true" empty-text="" class="inner-table" ref="c1TableRef">
                <el-table-column prop="category" label="类目" align="center" width="120"></el-table-column>
                <el-table-column label="1月" align="center">
                  <el-table-column prop="january_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="january_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="2月" align="center">
                  <el-table-column prop="february_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="february_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="3月" align="center">
                  <el-table-column prop="march_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="march_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="4月" align="center">
                  <el-table-column prop="april_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="april_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="5月" align="center">
                  <el-table-column prop="may_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="may_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="6月" align="center">
                  <el-table-column prop="june_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="june_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="7月" align="center">
                  <el-table-column prop="july_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="july_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="8月" align="center">
                  <el-table-column prop="august_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="august_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="9月" align="center">
                  <el-table-column prop="september_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="september_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="10月" align="center">
                  <el-table-column prop="october_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="october_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="11月" align="center">
                  <el-table-column prop="november_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="november_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="12月" align="center">
                  <el-table-column prop="december_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="december_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
<!--                <el-table-column label="年度" align="center">-->
<!--                  <el-table-column prop="annual_total_num" label="户数" align="center" width="100"></el-table-column>-->
<!--                  <el-table-column prop="annual_total_amount" label="金额" align="center" width="120"></el-table-column>-->
<!--                </el-table-column>-->
              </el-table>
            </div>
          </template>
          <template slot-scope="scope">
            <div class="expediting-fees-plan-table-cell-p">
              <div class="expediting-fees-plan-table-cell">
                <div>{{ scope.row.yusuan[0].category }}</div>
                <div v-for="(item,index) in scope.row.detail_info" :key="index">
                  {{item.category}}
                </div>
              </div>
              <el-table :data="scope.row.yusuan||[]" :show-header="false" row-class-name="rowClass" cell-class-name="cellClass" class="inner-table" ref="c2TableRef">
                <el-table-column prop="category" label="类目" align="center" width="120" class="inner-fix-col"></el-table-column>
                <el-table-column prop="month_1" label="1月" align="center" width="220"></el-table-column>
                <el-table-column prop="month_2" label="2月" align="center" width="220"></el-table-column>
                <el-table-column prop="month_3" label="3月" align="center" width="220"></el-table-column>
                <el-table-column prop="month_4" label="4月" align="center" width="220"></el-table-column>
                <el-table-column prop="month_5" label="5月" align="center" width="220"></el-table-column>
                <el-table-column prop="month_6" label="6月" align="center" width="220"></el-table-column>
                <el-table-column prop="month_7" label="7月" align="center" width="220"></el-table-column>
                <el-table-column prop="month_8" label="8月" align="center" width="220"></el-table-column>
                <el-table-column prop="month_9" label="9月" align="center" width="220"></el-table-column>
                <el-table-column prop="month_10" label="10月" align="center" width="220"></el-table-column>
                <el-table-column prop="month_11" label="11月" align="center" width="220"></el-table-column>
                <el-table-column prop="month_12" label="12月" align="center" width="220"></el-table-column>
<!--                <el-table-column prop="year" label="年度" align="center" width="220"></el-table-column>-->
              </el-table>
              <el-table :data="scope.row.detail_info||[]" :show-header="false" class="inner-table" ref="c3TableRef">
                <el-table-column prop="category" label="类目" align="center" width="120" class="inner-fix-col"></el-table-column>
                <el-table-column label="1月" align="center">
                  <el-table-column prop="january_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="january_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="2月" align="center">
                  <el-table-column prop="february_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="february_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="3月" align="center">
                  <el-table-column prop="march_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="march_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="4月" align="center">
                  <el-table-column prop="april_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="april_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="5月" align="center">
                  <el-table-column prop="may_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="may_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="6月" align="center">
                  <el-table-column prop="june_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="june_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="7月" align="center">
                  <el-table-column prop="july_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="july_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="8月" align="center">
                  <el-table-column prop="august_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="august_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="9月" align="center">
                  <el-table-column prop="september_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="september_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="10月" align="center">
                  <el-table-column prop="october_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="october_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="11月" align="center">
                  <el-table-column prop="november_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="november_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
                <el-table-column label="12月" align="center">
                  <el-table-column prop="december_num" label="户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="december_amount" label="金额" align="center" width="120"></el-table-column>
                </el-table-column>
<!--                <el-table-column label="年度" align="center">-->
<!--                  <el-table-column prop="annual_total_num" label="户数" align="center" width="100"></el-table-column>-->
<!--                  <el-table-column prop="annual_total_amount" label="金额" align="center" width="120"></el-table-column>-->
<!--                </el-table-column>-->
              </el-table>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="1-5月累计" align="center" width="690">
          <template #header>
            <div class="expediting-fees-plan-table-header">
              <el-table :data="[]" :show-header="true" empty-text="" class="inner-table">
                <el-table-column label="1-5月累计" align="center">
                  <el-table-column prop="cumulative_plan_num" label="计划户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="cumulative_plan_amount" label="计划金额" align="center" width="120"></el-table-column>
                  <el-table-column prop="cumulative_actual_num" label="实际户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="cumulative_actual_amount" label="实际户数" align="center" width="120"></el-table-column>
                  <el-table-column prop="cumulative_diff_num" label="差异户数" align="center" width="100"></el-table-column>
                  <el-table-column prop="cumulative_diff_amount" label="差异金额" align="center" width="120"></el-table-column>
                </el-table-column>

              </el-table>
            </div>
          </template>
          <template #default="scope">
            <el-table :data="scope.row.yusuan||[]" :show-header="false" row-class-name="rowClass" cell-class-name="cellClass" class="inner-table" ref="c2TableRef">
              <el-table-column prop="cumulative_plan_num" label="计划户数" align="center" width="100"></el-table-column>
              <el-table-column prop="cumulative_plan_amount" label="计划金额" align="center" width="120"></el-table-column>
              <el-table-column prop="cumulative_actual_num" label="实际户数" align="center" width="100"></el-table-column>
              <el-table-column prop="cumulative_actual_amount" label="实际户数" align="center" width="120"></el-table-column>
              <el-table-column prop="cumulative_diff_num" label="差异户数" align="center" width="100"></el-table-column>
              <el-table-column prop="cumulative_diff_amount" label="差异金额" align="center" width="120"></el-table-column>
            </el-table>
            <el-table :data="scope.row.detail_info||[]" :show-header="false" class="inner-table">
              <el-table-column prop="cumulative_plan_num" label="计划户数" align="center" width="100"></el-table-column>
              <el-table-column prop="cumulative_plan_amount" label="计划金额" align="center" width="120"></el-table-column>
              <el-table-column prop="cumulative_actual_num" label="实际户数" align="center" width="100"></el-table-column>
              <el-table-column prop="cumulative_actual_amount" label="实际户数" align="center" width="120"></el-table-column>
              <el-table-column prop="cumulative_diff_num" label="差异户数" align="center" width="100"></el-table-column>
              <el-table-column prop="cumulative_diff_amount" label="差异金额" align="center" width="120"></el-table-column>
            </el-table>
          </template>
        </el-table-column>

      </el-table-column>

      <el-table-column label="操作" align="center" width="100" fixed="right">
        <template #default="scope">
          <el-button v-if="scope.row.task_id" type="primary" size="mini" @click="$refs.viewFlowRef.show({task_id:scope.row.task_id})">审批流程</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="footer-pagination">
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageData.total" :page-size="pageData.per_page" :current-page="pageData.current_page"
        @current-change="pageChange"
      >
      </el-pagination>
    </div>

    <ViewFlow ref="viewFlowRef" />
    <CourtWin ref="courtWinRef" />
  </div>
</template>

<script>
import ButlerHttp from "../../common/ButlerHttp";
import {CommonHelp} from "../../common/CommonHelp";
import HeaderTip from "../../../Common/header-tip";
import ViewFlow from "../../../Common/ViewFlow";
import CourtWin from "../litigation/court/CourtWin";

export default {
  name: "ExpeditingFeesPlanContenzioso2",
  components: {CourtWin, ViewFlow, HeaderTip},
  inject:['where','reginWhere'],
  data() {
    return {
      loading:false,
      pageData:{
        current_page: 1,
        per_page: 20,
        data:[],
        total:0
      },
      statistics:{
        count:0,
        use_count:0,
        not_use_count:0,
        one_year_more_count:0,
      },
      // ========== 新增 ==========
      outerScrollWraps: [], // 外层表格滚动容器
      scrollLeftVal: 0 ,     // 横向滚动偏移量
      scrollLeftSetp:true,
    }
  },
  mounted() {
    this.getList();
    // ========== 新增：初始化滚动监听 ==========
    this.bindOuterTableScroll();
  },
  beforeDestroy() {
    // 移除滚动监听
    this.outerScrollWraps.forEach(wrap => {
      wrap.removeEventListener('scroll', this.handleOuterScroll);
    });
  },
  methods: {
    // 绑定外层表格滚动事件
    bindOuterTableScroll() {
      const outerTable = this.$refs.fTableRef.$el;
      if (!outerTable) return;
      // 取外层表格表头、表体滚动容器
      const headerWrap = outerTable.querySelector('.el-table__header-wrapper');
      const bodyWrap = outerTable.querySelector('.el-table__body-wrapper');
      this.outerScrollWraps = [headerWrap, bodyWrap].filter(Boolean);
      console.log(this.outerScrollWraps)

      this.outerScrollWraps.forEach(wrap => {
        wrap.addEventListener('scroll', this.handleOuterScroll);
        // 初始执行一次，复位位置
        this.handleOuterScroll.call(wrap);
      });
    },

    // 滚动触发：让所有子表第一列反向偏移，实现固定
    handleOuterScroll() {
      // 取当前横向滚动值
      if((this.scrollLeftVal!==(this.outerScrollWraps[0].scrollLeft || 0))&&this.scrollLeftSetp){
        this.scrollLeftSetp=false;
        this.scrollLeftVal = this.outerScrollWraps[0].scrollLeft || 0;

        // console.log(this.scrollLeftVal)


        if(this.scrollLeftVal>2600){
          // console.log(this.scrollLeftVal)
          let t=this.$refs.c1TableRef.$el.getBoundingClientRect();

          // 过外边框 363.28125
          // 刚刚过线 369.28125
          if(t.left<372){
            // -t.left
            let x=372 - t.left;
            this.setFx(x)
          }else {
            this.setFx(0)
          }
        }else {
          if(this.scrollLeftVal>2770){
            this.setFx(0)
          }else {
            this.scrollLeftSetp=true;
          }
        }
      }

    },
    setFx(x){
      let cells = document.querySelectorAll(".expediting-fees-plan-table-cell");
      let header = document.querySelector(".expediting-fees-plan-table-header-title");
      cells.forEach( cell=> {
        if(cell) {
          cell.style.left = `${x}px`;
          cell.style.visibility = x>0?"visible":"hidden";
        }
      })

      if(header) {
        header.style.left = `${x}px`;
        header.style.visibility = x>0?"visible":"hidden";
      }
      this.scrollLeftSetp=true;
    },
    getList(){
      const that=this;
      that.loading=true;
      let where = {
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name
      }
      ButlerHttp.post("YearPlan/getMasterList?page="+that.pageData.current_page+"&per_page="+that.pageData.per_page,{
        ...where
      },ret=>{
        that.loading=false;
        if(ret.code){
          that.pageData=ret.data;
        }
      });
      this.getMasterStatistics();
    },
    getMasterStatistics(){
      const that=this;
      let where = {
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name
      }
      ButlerHttp.post("YearPlan/getMasterStatistics",{
        ...where
      },ret=>{
        if(ret.code){
          that.statistics=ret.data;
        }
      })
    },
    pageChange(i) {
      const that=this;
      that.pageData.current_page = i;
      CommonHelp.debounce(()=>{
        that.getList()
      },500,that);
    },
    exportExcel(){
      const that=this;
      const loading=that.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let where = {
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name
      }
      ButlerHttp.post("YearPlan/getMasterExcel",{
        ...where
      },ret=>{
        loading.close()
        if (ret.code) {
          window.open(ret.data)
        } else {
          that.$message.error(ret.msg);
        }
      })
    },
    importExcel() {
      const that = this;
      ButlerHttp.uploadFile(file => {
        const loading = that.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        ButlerHttp.post("YearPlan/importMasterExcel", {
          file: file,
        }, res => {
          loading.close()
          // console.log(that.reginWhere.type_id)
          if (res.code) {
            let timeStr = (new Date()).getTime()
            if([4,5].includes(that.reginWhere.type_id)){
              ERP.navigateTo(`/flow/FlowView?sheet_id=363&master_id=299&timeValue=${timeStr}&batch_number=${res.data}`)
            }else {
              ERP.navigateTo(`/flow/FlowView?sheet_id=308&master_id=248&timeValue=${timeStr}&batch_number=${res.data}`)
            }

          } else {
            that.$message.error(res.msg);
          }
        });
      })
    },
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_region":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_name":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
  }
}
</script>

<style lang="scss" scoped>
>>>.inner-table {
  .inner-fix-col {
    //z-index: 99 !important;
    //background: #fff !important;
    //box-shadow: 1px 0 0 #ebeef5 !important;
    //transition: none !important;
    ///* 禁止位移动画，防止抖动 */
    //will-change: transform; // 禁止位移动画
    //transform: translateZ(0); // 禁止位移动画
    //backface-visibility: hidden; // 禁止位移动画
  }
}
.expediting-fees-plan-contenzioso2{
  .expediting-fees-plan-contenzioso2-header{
    //margin-bottom: 10px;
  }
  .expediting-fees-plan-table-cell-p{
    position: relative;

    .expediting-fees-plan-table-cell{
      position: absolute;
      display: flex;
      flex-direction: column;
      z-index: 1;
      top: 0;
      left: 0;
      //margin: 8px;
      visibility: hidden;
      background-color: white;

      div{
        //height: 40px;
        //line-height: 40px;
        padding-top: 8px;
        padding-bottom: 8px;
        width: 120px;
        border-right: 1px solid #000000;
        border-bottom: 1px solid #000000;

        transition: left 1ms ease-in-out;

        &:first-child{
          height: 40px;
          padding-top: 0;
        }
        &:last-child{
          border-bottom: none;
        }
      }
    }
  }

  .expediting-fees-plan-table-header{
    position: relative;

    .expediting-fees-plan-table-header-title{
      position: absolute;
      top: 1px;
      left: 1px;
      z-index: 1;
      width: 120px;
      height: 80.75px;
      line-height: 80.75px;
      text-align: center;
      border-right: 1px solid #000000;
      visibility: hidden; // 隐藏
      background-color: white;

      transition: left 1ms ease-in-out;
    }

    >>>.el-table__empty-block{
      display:none;
    }
  }

  >>> .el-table .rowClass{
    border-bottom: 1px solid #000000;
  }

  >>> .el-table .cellClass{
    border-bottom: 1px solid #000000;
    padding: 0;
    line-height: 40px;

    .cell{
      border-bottom: 1px solid #000000;
      height: 40px;
    }
  }

  >>>.el-table--border, .el-table--group{
    border: 1px solid #000000;
  }
  >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid #000000;
  }
  >>>.el-table--border .el-table__cell, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
    border-right: 1px solid #000000;
  }
  >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid #000000;
  }
  >>>.el-table--border th.el-table__cell, .el-table__fixed-right-patch{
    border-bottom: 1px solid #000000;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/plan/ExpeditingFeesPlanContenzioso2.vue